export default [
  {
    path: '/student-card-activators',
    name: 'student-card-activator',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-card-activator/index.vue')
  }
]
